import BulkEditInvitationsStore from '.';
import { Deactivating, InvitationStatus, Reactivating } from './Types';

interface InvitationsOut {
  registration_invitations: {
    invitation_status: InvitationStatus;
    registration_invitation_ids: ReadonlyArray<number>;
  };
  learning_collection_id: number;
}

export const bulkEditInvitationsEncoder = (
  store: BulkEditInvitationsStore,
  state: Deactivating | Reactivating,
): InvitationsOut => ({
  registration_invitations: {
    registration_invitation_ids: state.multicheckStore.selected.map((r) => r.payload.id),
    invitation_status: state.invitationStatus,
  },
  learning_collection_id: store.invitationsStore.learningCollectionId,
});
